import { createSlice } from "@reduxjs/toolkit";
import eventApi from "../api/event";
import { EventModel } from "../types/event";

const slice = createSlice({
  name: "event",
  initialState: {
    events: [],
  } as EventState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(eventApi.endpoints.getEvents.matchPending, (state) => {
      return {
        ...state,
        events: [],
      };
    });
    builder.addMatcher(
      eventApi.endpoints.addEventView.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          ...payload,
        };
      }
    );
    builder.addMatcher(
      eventApi.endpoints.getEvents.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          events: payload,
        };
      }
    );
    builder.addMatcher(
      eventApi.endpoints.addEditEvent.matchFulfilled,
      (state, { payload }) => {
        let events = state.events.slice();
        const index = events.findIndex((c) => c.eventId == payload[0].eventId);
        if (index > -1) {
          events[index] = payload[0];
        } else {
          events.splice(0, 0, ...payload);
        }
        return {
          ...state,
          events,
        };
      }
    );
  },
});

export const event = slice.reducer;

export interface EventState {
  events: EventModel[];
}
